<template>
  <div>
    <el-dialog
      :visible="visible"
      title="操作记录-更改支付时间"
      width="800px"
      @close="handleClose"
    >
      <div class="dialog-wrap">
        <el-table
          size="mini"
          v-horizontal-scroll
          :data="tableData"
          stripe
          style="width: 100%"
          tooltip-effect="dark"
        >
          <el-table-column label="变更时间" prop="create_time">
          </el-table-column>
          <el-table-column label="变更内容" prop="detail" width="500">
          </el-table-column>
          <el-table-column label="变更人" prop="staff.name"> </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOperationLogApi } from "@/api/store";
import { dateFormat } from "@/utils/timeFormat";

export default {
  props: ["visible"],
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          this.getList({
            page: 1,
            page_size: 10,
          });
        }
      },
    },
  },
  methods: {
    getList(option) {
      let data = { ...option };
      data.code = [30515];
      getOperationLogApi(data).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              item.create_time * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleClose() {
      this.$emit("change");
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wrap {
  padding-bottom: 45px;
}
.flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
